import Button from '@mui/material/Button';
import { hexWithOpacity, toTitleCase } from 'common/utils';
import { colors } from 'styles/colors';
import useStyles from './styles';
import Circle from 'components/common/Circle/Circle';
import { EUserStatus } from 'enum';
import CustomText from 'components/common/CustomText/CustomText';
import { EVerificationCodeStatus } from 'enum/EVerificationCodeStatus';

interface Props {
  status: EVerificationCodeStatus;
}

export default function VerificationCodeStatus({ status }: Props) {
  const styles = useStyles();

  const getStatusColor = (codeStatus: EVerificationCodeStatus) => {
    switch (codeStatus) {
      case EVerificationCodeStatus.ACTIVE:
        return colors.success;
      case EVerificationCodeStatus.EXPIRED:
        return colors.error;
      default:
        return colors.text;
    }
  }

  return (
    <div>
      <Button
        className={styles.statusOuterButton}
        sx={{
          paddingLeft: 0,
          backgroundColor: hexWithOpacity(getStatusColor(status), 0.1),
          color: getStatusColor(status),
          '&&:hover': {
            bgcolor: hexWithOpacity(getStatusColor(status), 0.3),
            color: getStatusColor(status),
          },
        }}
      >
        <Circle
          boxSize={20}
          circleSize={6}
          color={getStatusColor(status)}
        />
        <CustomText text={toTitleCase(status)} color={getStatusColor(status)} fontSize={14} />
      </Button>
    </div>
  );
}
